import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import ArrowRight from '@mui/icons-material/ArrowRight';

import { Button } from 'uikit/buttons';

import styles from '../styles/learningObjectivesListItemToggleExpandButton.module.scss';

const LearningObjectivesListItemToggleExpandButton = ({ item, onCollapse, onExpand }) => {
  const {
    isExpanded,
    data: { isGenerating, isReadOnly },
    hasChildren,
  } = item;

  if (!hasChildren) return <div className={styles.placeholder} />;

  const handleToggleExpandButton = () => (isExpanded ? onCollapse(item.id) : onExpand(item.id));

  return (
    <Button
      onClick={handleToggleExpandButton}
      className={classnames(styles.element, { [styles.isExpanded]: isExpanded })}
      ariaLabel={isExpanded ? i18n.t('learning-objectives.collapse-button') : i18n.t('learning-objectives.expand-button')}
      variant="ghost"
      size="xsmall"
      icon={<ArrowRight />}
      isDisabled={isReadOnly || isGenerating}
      testId="learning-objectives-toggle-expand-button"
    />
  );
};

LearningObjectivesListItemToggleExpandButton.propTypes = {
  item: PropTypes.shape({
    isExpanded: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.number),
    hasChildren: PropTypes.bool,
    isReadOnly: PropTypes.bool,
  }).isRequired,
  onCollapse: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
};

export default React.memo(LearningObjectivesListItemToggleExpandButton);
